import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Post from "./Post";
import PostAdd from "./PostAdd";
import PostList from "./PostList";
import { withLocalize } from "react-localize-redux";

function Community(props) {
  const postAdded = () => {setaddedCount(addedCount + 1)};
const [addedCount, setaddedCount] = useState(0)
let langCode = "en";
if (props.activeLanguage !== undefined) {
  langCode = props.activeLanguage.code;
}
  return (
    <ul class="timeline timeline-noline">
      <PostAdd Lang={langCode} postAdded={postAdded} crsnum={props.match.params.crsnum} />
      <PostList Lang={langCode} addedCount={addedCount} crsnum={props.match.params.crsnum} />
    </ul>
  );
}

export default  withLocalize(Community)


// WEBPACK FOOTER //
// ./src/pages/course/Community/Community.js